export const shadows = {
  shadow01: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
  // Janelas de diálogo (escolha e confirmação).
  shadow02: '0 8px 24px rgba(10, 13, 20, 0.12)',
};
